import { jsxs as g, Fragment as P, jsx as u } from "react/jsx-runtime";
import { useState as a, useRef as p, useCallback as S, useEffect as y, createElement as j } from "react";
import { EqualSizeGrid as F } from "../EqualSizeGrid/EqualSizeGrid.js";
import { InfoPanel as G } from "../InfoPanel/InfoPanel.js";
import { classes as _ } from "../../utils/helpers.js";
import { blockLayoutsMap as q } from "../../settings.js";
import '../../assets/BasicGridModule.css';function T({
  children: z,
  gap: b = "1.5rem",
  itemsPerRow: k = 4,
  classname: L = "",
  title: d = "",
  infoPanel: A,
  itemComponent: o = {
    layout: "ImageCard",
    props: {
      fullCardClickable: !1
    }
  },
  infoPanelComponent: n = {
    layout: "",
    backButtonLabel: "Return to List",
    resourceList: [],
    classname: ""
  },
  items: E = [],
  customClicksHandler: I = null,
  noAnimation: x = !1
}) {
  const [r, f] = a(!1), [C, R] = a({}), [m, B] = a(null), [v, c] = a("entering"), [M, N] = a(x ? null : !0), l = p("entering"), e = p(null), i = S(() => {
    e.current.children[0].addEventListener("animationstart", () => {
      console.log("animation started"), e.current.children[0].addEventListener("animationend", i, { once: !0 });
    }), console.log("stateRef.current", l.current), console.log("infoPanelOpen", r), l.current === "exiting" ? (c("entering"), l.current = "entering", f(!0)) : c("idle");
  }, []), O = (t) => {
    t.type === "info-panel" && (R(n.resourceList.find((s) => Number.parseInt(s.id, 10) === Number.parseInt(t.resourceId, 10))), N(!1), l.current = "exiting", c("exiting"));
  };
  return y(() => {
    B(q.get(o.layout));
  }, [o.layout]), y(() => {
    var t, s, h;
    !r && e.current !== null && ((t = e.current) != null && t.children, e.current.children.length && ((s = e.current.children[0]) == null || s.removeEventListener("animationend", i, { once: !0 }), (h = e.current.children[0]) == null || h.addEventListener("animationend", i, { once: !0 })));
  }, [r, i]), /* @__PURE__ */ g(P, { children: [
    !r && /* @__PURE__ */ g("basic-grid-module", { "data-state": v, "first-entry": M, ref: e, children: [
      d !== "" && /* @__PURE__ */ u("h2", { className: _(["basic-grid-module__header", "h4"]), children: d }),
      m !== null && /* @__PURE__ */ u(
        F,
        {
          gap: b,
          itemsPerRow: k,
          classname: L,
          children: E.map(
            (t) => /* @__PURE__ */ j(
              m,
              {
                ...t,
                ...o.props,
                relatedResourceId: t.id,
                handleClicks: I ?? O,
                key: `grid-item-${Math.round(Math.random() * 1e7)}`
              }
            )
          )
        }
      )
    ] }),
    r && n.layout && /* @__PURE__ */ u(
      G,
      {
        className: "grid-info-panel",
        onBackClicked: () => {
          f(!1);
        },
        backButtonLabel: n.backButtonLabel,
        layoutComponent: {
          layout: n.layout,
          props: {
            ...C
          }
        },
        classname: n.classname
      }
    )
  ] });
}
export {
  T as BasicGridModule,
  T as default
};
